import React from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Heating from "./Heating";
import Cooling from "./Cooling";
import Mixing from "./Mixing";
import AdiabaticHumidifing from "./AdiabaticHumidifing";
import SteamHumidifing from "./SteamHumidifing";
import {
  changePointProcess,
  deleteProcessPoint,
} from "../../../actions/summerPointsActions";
import {
  changeWinterPointProcess,
  deleteWinterProcessPoint,
} from "../../../actions/winterPointsActions";
import { weatherCtx } from "../../../utils/hooks/mollierWeatherContext";
import { useDispatch, useSelector } from "react-redux";
import { useContext } from "react";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { useTranslation } from "react-i18next";
import Grid from "@mui/material/Grid";

function AirProcess(props) {
  const [processName, setProcess] = React.useState("");
  const { summerWeather } = useContext(weatherCtx);
  const {t} = useTranslation()

  const process = useSelector((state) => state.processPoint.summerPoints).find(
    (point) => point.id === props.key
  );
  //const proccessValue = useSelector;
  const dispatch = useDispatch();

  function handleProcessChange(event) {
    setProcess(event.target.value);
    if (props.processDetails.process !== event.target.value) {
      summerWeather
        ? dispatch(
            changePointProcess(event.target.value, props.processDetails.id)
          )
        : dispatch(
            changeWinterPointProcess(
              event.target.value,
              props.processDetails.id
            )
          );
    }
  }
 

  const processNameMapping = {
    10: "heating",
    20: "cooling",
    30: "mixing",
    40: "humidifing",
    50: "adiabatic",
  };
  const backgroundProcessColor = {
    10: "#feccc9",
    20: "#d0edf8",
    30: "#f9e5cf",

    40: "#d4daf7",
    50: "#edf8d0",
    "": "#fff",
  };
  const borderProcessColor = {
    10: "#fd847e",
    20: "#77cceb",
    30: "#edb574",

    40: "#7f91e7",
    50: "#D4EE8D",
    "": "#fff",
  };
 
  function deleteProcess() {
    summerWeather
      ? dispatch(deleteProcessPoint(props.processDetails.id))
      : dispatch(deleteWinterProcessPoint(props.processDetails.id));
  }

  return (
    <Box sx={{ flexGrow: 1 }} m={2}>
      <Paper
        m={2}
        sx={{
          backgroundColor: backgroundProcessColor[props.processDetails.process],
          border: `2px solid ${
            borderProcessColor[props.processDetails.process]
          }`,
        }}
      >
        <Grid container direction="row">
          <Grid item xs={1} mt={3}>
            <IconButton
              aria-label="delete"
              color="primary"
              onClick={deleteProcess}
            >
              <DeleteOutlineIcon />
            </IconButton>
          </Grid>
          <Grid item xs={11} mt={1}>
            <FormControl sx={{ minWidth: "170px", my: "12px" }} my={2}>
              <InputLabel
                mt={2}
                id="demo-simple-select-label"
                MenuProps={{
                  sx: {
                    "&& .MuiMenuItem-gutters": {
                      backgroundColor: "pink",
                      color: "red",
                    },
                  },
                }}
              >
                {t("mollier.process")}
              </InputLabel>
              <Select
                mb={2}
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={props.processDetails.process}
                label="process"
                name="variable1"
                onChange={handleProcessChange}
                sx={{ "MuiFormControl-root": { backgroundColor: "red" } }}
                MenuProps={{
                  sx: {
                    "MuiOutlinedInput-root MuiInputBase-root MuiInputBase-colorPrimary MuiInputBase-formControl  css-1c7bu1-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root":
                      {
                        backgroundColor: "pink",
                        color: "red",
                      },
                  },
                }}
              >
                <MenuItem value={10}>{t("mollier.heating")}</MenuItem>
                <MenuItem value={20}>{t("mollier.cooling")}</MenuItem>
                <MenuItem value={30}>{t("mollier.mixing")}</MenuItem>
                <MenuItem value={40} disabled>
                {t("mollier.adiabaticHum")}
                </MenuItem>
                <MenuItem value={50} disabled>
                {t("mollier.steamHum")}
                </MenuItem>
                {/*<MenuItem value={60}>Theoretic process</MenuItem>*/}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={1}></Grid>
          <Grid item xs={11}>
            {props.processDetails.process == 10 && (
              <Heating
                processID={props.processDetails.id}
                heatingTemperature={props.processDetails.temperatureDryBulb}
              />
            )}
            {props.processDetails.process == 20 && (
              <Cooling
                processID={props.processDetails.id}
                coolingTemperature={props.processDetails.temperatureDryBulb}
              />
            )}
            {props.processDetails.process == 30 && (
              <Mixing processID={props.processDetails.id} />
            )}
            {props.processDetails.process == 40 && (
              <AdiabaticHumidifing processID={props.processDetails.id} />
            )}
            {props.processDetails.process == 50 && (
              <SteamHumidifing
                relativeHumidity={props.processDetails.relativeHumidity}
                processID={props.processDetails.id}
              />
            )}
          </Grid>
        </Grid>
      </Paper>{" "}
    </Box>
  );
}

export default AirProcess;
